"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var __read = this && this.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
      r,
      ar = [],
      e;

  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) {
      ar.push(r.value);
    }
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }

  return ar;
};

var __values = this && this.__values || function (o) {
  var s = typeof Symbol === "function" && Symbol.iterator,
      m = s && o[s],
      i = 0;
  if (m) return m.call(o);
  if (o && typeof o.length === "number") return {
    next: function next() {
      if (o && i >= o.length) o = void 0;
      return {
        value: o && o[i++],
        done: !o
      };
    }
  };
  throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IbanForm = void 0;

var react_1 = __importStar(require("react"));

var Iban_1 = __importDefault(require("../../models/Iban"));

var IbanBetaNoMandat_1 = __importDefault(require("../../models/IbanBetaNoMandat"));

var react_theme_components_1 = require("@suezenv/react-theme-components");

var Form_1 = __importDefault(require("../Form/Form"));

var Input_1 = __importDefault(require("../Form/Input"));

var clsx_1 = __importDefault(require("clsx"));

var Iban_2 = __importDefault(require("./Iban"));

var IbanInput_1 = require("./IbanInput");

var checkHasErrorIban_1 = __importDefault(require("../../utils/checkHasErrorIban"));

exports.IbanForm = function (_a) {
  var e_1, _b;

  var _c = _a.iban,
      iban = _c === void 0 ? '' : _c,
      isMandat = _a.isMandat,
      loaderSubmit = _a.loaderSubmit,
      messageError = _a.messageError,
      _d = _a.showFullForm,
      showFullForm = _d === void 0 ? false : _d,
      onSubmit = _a.onSubmit,
      mobile = _a.mobile,
      firstName = _a.firstName,
      lastName = _a.lastName,
      _e = _a.modeOfPayment,
      modeOfPayment = _e === void 0 ? 'paymentEtip' : _e,
      isIbanDifferentWithSearchMandate = _a.isIbanDifferentWithSearchMandate,
      _f = _a.fromPlatform,
      fromPlatform = _f === void 0 ? 'part' : _f;

  var _g = __read(react_1.useState({
    mobile_phone: mobile,
    first_name: firstName,
    last_name: lastName
  }), 2),
      initialValues = _g[0],
      setInitialValues = _g[1];

  var _h = __read(react_1.useState(false), 2),
      hasUpdateIban = _h[0],
      setHasUpdateIban = _h[1];

  react_1.useEffect(function () {
    setInitialValues({
      mobile_phone: mobile,
      first_name: firstName,
      last_name: lastName
    });
  }, [mobile, firstName, lastName]);

  var _j = __read(react_1.useState(iban.length === 0 ? true : false), 2),
      showFormIban = _j[0],
      setShowFormIban = _j[1];

  var constructModelNoIban = function constructModelNoIban(model) {
    var modelNoIban = __assign({}, model);

    if (!showFormIban) {
      for (var index = 1; index < 9; index++) {
        delete modelNoIban["iban_field_" + index];
      }
    }

    return modelNoIban;
  };

  if (modeOfPayment === 'paymentEtip') {
    delete Iban_1.default.civility;

    if (isIbanDifferentWithSearchMandate === true) {
      delete Iban_1.default.mobile_phone;
    }
  }

  var currentModel = Iban_1.default;

  if (fromPlatform === 'beta' && !isMandat) {
    var modelIbanBetaNoMandat = showFormIban ? IbanBetaNoMandat_1.default : constructModelNoIban(IbanBetaNoMandat_1.default);
    currentModel = modelIbanBetaNoMandat;
  } else if (!showFormIban) {
    currentModel = constructModelNoIban(Iban_1.default);
  }

  var _k = __read(react_1.useState(currentModel), 2),
      modelForm = _k[0],
      setModelForm = _k[1];

  var last_name = Iban_1.default.last_name,
      first_name = Iban_1.default.first_name,
      mobile_phone = Iban_1.default.mobile_phone,
      civility = Iban_1.default.civility,
      iban_props = __rest(Iban_1.default, ["last_name", "first_name", "mobile_phone", "civility"]);

  var company_name = IbanBetaNoMandat_1.default.company_name;
  var refsInput = {};

  try {
    for (var _l = __values(Object.keys(iban_props)), _m = _l.next(); !_m.done; _m = _l.next()) {
      var name_1 = _m.value;
      refsInput[name_1] = react_1.default.useRef(null);
    }
  } catch (e_1_1) {
    e_1 = {
      error: e_1_1
    };
  } finally {
    try {
      if (_m && !_m.done && (_b = _l.return)) _b.call(_l);
    } finally {
      if (e_1) throw e_1.error;
    }
  }

  var labelIban = 'Veuillez saisir vos coordonnées de compte IBAN';
  react_1.useEffect(function () {
    if (showFullForm) {
      setShowFormIban(true);
    }
  });
  react_1.useEffect(function () {
    var _a;

    if (hasUpdateIban) {
      (_a = refsInput['iban_field_1'].current) === null || _a === void 0 ? void 0 : _a.focus();
    }
  }, [hasUpdateIban]);

  var onSubmitIntercept = function onSubmitIntercept(dataForm) {
    var newData = __assign({}, dataForm);

    if (newData === null || newData === void 0 ? void 0 : newData.mobile_phone) {
      newData.mobile_phone = newData.mobile_phone.replace(/ /g, '');
    }

    onSubmit(newData);
  };

  return react_1.default.createElement(Form_1.default, {
    onSubmit: onSubmitIntercept,
    validationSchema: modelForm,
    initialValues: initialValues
  }, function (_a) {
    var values = _a.values,
        isValid = _a.isValid,
        setFieldValue = _a.setFieldValue;

    var onChangeRefs = function onChangeRefs(selectedOption) {
      setFieldValue('civility', selectedOption);
    };

    var updateIban = function updateIban() {
      var updateModel = Iban_1.default;

      if (fromPlatform === 'beta' && !isMandat) {
        updateModel = IbanBetaNoMandat_1.default;
      }

      setHasUpdateIban(true);
      setModelForm(updateModel);
      setShowFormIban(!showFormIban);
      setInitialValues(values);
    };

    return react_1.default.createElement(react_1.default.Fragment, null, react_1.default.createElement("div", {
      className: "row"
    }, react_1.default.createElement(react_theme_components_1.SzTypographie, {
      weight: "bold",
      className: "title-page mb-0 col-md-12 col-12"
    }, "Coordonn\xE9es bancaires")), modeOfPayment === 'paymentAuto' && fromPlatform === 'part' && react_1.default.createElement("div", {
      className: "row mt-3 mb-2"
    }, react_1.default.createElement("div", {
      className: "col-md-2"
    }, react_1.default.createElement("label", {
      className: "sz-form-group__label sz-line-height-normal mb-1",
      htmlFor: 'civility'
    }, react_1.default.createElement(react_theme_components_1.SzTypographie, {
      color: "inactive",
      weight: "bold",
      tag: "span"
    }, civility.label)), react_1.default.createElement(react_theme_components_1.SzSelect, __assign({}, civility, {
      id: "civility",
      placeholder: 'Votre civilité',
      value: values.civility,
      onChange: onChangeRefs,
      className: clsx_1.default('cy-civility px-0'),
      name: "civility"
    })))), react_1.default.createElement("div", {
      className: "row mt-2 mb-4"
    }, fromPlatform === 'part' && react_1.default.createElement(react_1.default.Fragment, null, react_1.default.createElement(Input_1.default, __assign({
      name: 'last_name'
    }, last_name, {
      changeCase: "upperCase",
      className: "cy-last-name col-md-4"
    })), react_1.default.createElement(Input_1.default, __assign({
      name: 'first_name'
    }, first_name, {
      changeCase: "upperCase",
      className: "cy-first-name col-md-4"
    }))), !isMandat && fromPlatform === 'beta' && react_1.default.createElement(react_1.default.Fragment, null, react_1.default.createElement(Input_1.default, __assign({
      name: 'company_name'
    }, company_name, {
      changeCase: "upperCase",
      className: "cy-company-name col-md-4"
    }))), !isMandat && fromPlatform === 'part' && react_1.default.createElement(Input_1.default, __assign({
      name: 'mobile_phone'
    }, mobile_phone, {
      className: "cy-mobile-phone col-md-4"
    }))), !isMandat && modeOfPayment === 'paymentAuto' && fromPlatform === 'beta' && react_1.default.createElement("div", {
      className: "row mt-2 mb-4"
    }, react_1.default.createElement(Input_1.default, __assign({
      name: 'mobile_phone'
    }, mobile_phone, {
      className: "cy-mobile-phone col-md-4"
    })), react_1.default.createElement("div", {
      className: "col-md-4"
    }, react_1.default.createElement(react_theme_components_1.SzAlert, {
      variant: "info",
      transparent: true,
      className: "cy-info-mobile py-2"
    }, "Ce num\xE9ro de t\xE9l\xE9phone est utilis\xE9 uniquement pour vous envoyer un code par sms afin de signer votre mandat de pr\xE9l\xE8vement."))), !isMandat && modeOfPayment === 'paymentEtip' && react_1.default.createElement("div", {
      className: "row"
    }, react_1.default.createElement("div", {
      className: "offset-md-8 col-md-4"
    }, react_1.default.createElement(react_theme_components_1.SzAlert, {
      variant: "info",
      transparent: true,
      className: "cy-info-mobile py-2"
    }, "Ce num\xE9ro de t\xE9l\xE9phone est utilis\xE9 uniquement pour vous envoyer un code par sms afin de signer votre mandat de pr\xE9l\xE8vement."))), !showFormIban ? react_1.default.createElement(Iban_2.default, {
      iban: iban,
      showTitulaire: false,
      onClick: updateIban
    }) : react_1.default.createElement(react_1.default.Fragment, null, react_1.default.createElement("div", {
      className: "row my-3"
    }, react_1.default.createElement(react_theme_components_1.SzTypographie, {
      weight: "regular",
      className: "col-md-12 title-page mb-" + (iban ? '2' : '3')
    }, labelIban), react_1.default.createElement(IbanInput_1.IbanInput, null), react_1.default.createElement("div", {
      className: clsx_1.default('col-12', {
        'd-none': !checkHasErrorIban_1.default(values)
      })
    }, react_1.default.createElement(react_theme_components_1.SzAlert, {
      variant: "danger"
    }, "Valeur incorrecte"))), react_1.default.createElement("div", {
      className: "row"
    }, react_1.default.createElement("div", {
      className: "col-md-12"
    }, react_1.default.createElement(react_theme_components_1.SzAlert, {
      variant: "info",
      transparent: true,
      className: "py-2"
    }, "Les finalit\xE9s du traitement relatif \xE0 vos donn\xE9es personnelles, num\xE9riques et t\xE9l\xE9phoniques, ainsi que les destinataires de ce traitement et l\u2019\xE9tendue de vos droits sont consultables dans les conditions d'utilisation du site.", react_1.default.createElement("br", null), "Si vous souhaitez utiliser un compte qui n\u2019est pas domicili\xE9 en France ou Monaco , nous vous invitons \xE0 contacter le Service Client.")))), messageError && react_1.default.createElement("div", {
      className: "row",
      style: {
        marginLeft: '-4.6rem',
        marginRight: '-4.6rem',
        background: 'var(--gray-0)',
        padding: '1rem 4.6rem'
      }
    }, react_1.default.createElement(react_theme_components_1.SzAlert, {
      variant: 'danger',
      className: 'col-12 mb-0 bg-transparent'
    }, messageError)), react_1.default.createElement("div", {
      className: "row position-relative justify-content-between",
      style: {
        marginLeft: '-4.6rem',
        marginRight: '-4.6rem',
        background: 'var(--gray-0)',
        padding: '1rem 4.6rem'
      }
    }, react_1.default.createElement(react_theme_components_1.SzButton, {
      loader: loaderSubmit,
      className: "cy-btn-submit col-7 col-md-3 ml-auto",
      isDisabled: !isValid,
      type: "submit"
    }, "Etape suivante")));
  });
};

exports.default = exports.IbanForm;